import { atom, DefaultValue, selector } from "recoil"
import { ActiveSpeaker } from "./types"

export const defaultActiveSpeaker = {
  uid: ""
}

const activeSpeakerAtom = atom<ActiveSpeaker>({
  key: "activeSpeakerAtom",
  default: defaultActiveSpeaker
})

export const activeSpeakerSelector = selector({
  key: "activeSpeakerSelector",
  get: ({ get }) => {
    return get(activeSpeakerAtom)
  },
  set: ({ set }, activeSpeaker: ActiveSpeaker | DefaultValue) => {
    set(activeSpeakerAtom, activeSpeaker)
  }
})

interface ActiveSpeakerCallbackSelectorProps {
  handleReturnData?: () => Promise<ActiveSpeaker>
}

export const activeSpeakerCallbackSelector =
  selector<ActiveSpeakerCallbackSelectorProps>({
    key: "activeSpeakerCallbackSelector",
    get: ({ getCallback, get }) => {
      const handleReturnData = getCallback(({ snapshot }) => async () => {
        const data = await snapshot.getPromise(activeSpeakerAtom)
        return data
      })
      return { handleReturnData }
    }
  })
